import { SignUpCompletion } from '../components/Authentication/SignUpCompletion/SignUpCompletion'

export const SignUpCompletionPage = () => {
    return <SignUpCompletion />
}
